<template>
	<div>
		<h1>Sample Size</h1>

		<i>
			Estimated number of participants needed to achieve study objectives and
			how it was determined, including clinical and statistical assumptions
			supporting any sample size calculations
		</i>

		<InputSelectDropdown
			question="What trial type did you perform?"
			:options="trialTypeOptions"
			v-model="$tera.project.TrialWizard.trialType"
			bookmark="trial-type"
		/>

		<i v-if="$tera.project.TrialWizard.trialType != 'non-inferiority'">
			To calculate the sample size we suggest using Power and copying the text
			it provides.
			<a href="https://vbiostatps.app.vumc.org/ps/" target="_blank"
				>https://vbiostatps.app.vumc.org/ps/</a
			>
		</i>

		<i v-if="$tera.project.TrialWizard.trialType == 'non-inferiority'">
			For non-inferiority trials, we recommend using:
			<a href="https://www.sealedenvelope.com/" target="_blank"
				>Sealed Envelope | Randomisation (randomization) and online databases
				for clinical trials</a
			>
		</i>

		<InputTextSingleLine
			v-if="$tera.project.TrialWizard.trialType == 'other'"
			question="What is the trial type?"
			placeholder=""
			v-model="$tera.project.TrialWizard.trialTypeOther"
			bookmark="trial-type"
		/>

		<!--New added-->
		<InputSelectMulti
			question="Description of trial design including type of trial"
			:options="trialDesignOptions"
			v-model="$tera.project.TrialWizard.trialDesign"
			bookmark="trial-design"
		/>

		<InputSelectDropdown
			question="What is the study power of the trial?"
			:options="studyPowerOptions"
			v-model="$tera.project.TrialWizard.studyPower"
			bookmark="trial-power"
		/>

		<InputTextSingleLine
			v-if="$tera.project.TrialWizard.studyPower == 'other'"
			question="What is the study power?"
			placeholder=""
			v-model="$tera.project.TrialWizard.studyPowerOther"
			bookmark="trial-power"
		/>

		<InputSelectDropdown
			question="What is the level of significance?"
			:options="levelOfSignificanceOptions"
			v-model="$tera.project.TrialWizard.levelOfSignificance"
			bookmark="levelof-significance"
		/>

		<InputTextSingleLine
			v-if="$tera.project.TrialWizard.levelOfSignificance == 'other'"
			question="What is the level of significance?"
			placeholder=""
			v-model="$tera.project.TrialWizard.levelOfSignificanceOther"
			bookmark="levelof-significance"
		/>

		<InputTextSingleLine
			question="What was the sample size?"
			placeholder="e.g.1000"
			v-model="$tera.project.TrialWizard.sampleSize"
			bookmark="sample-size"
		/>

		<InputTextSingleLine
			question="What effect size is the study powered for?"
			placeholder="e.g. medium effect size"
			v-model="$tera.project.TrialWizard.effectSize"
			bookmark="study-power"
		/>

		<InputTextSingleLine
			question="What proportion of participant drop-outs are you expecting?"
			placeholder="e.g. 10%"
			v-model="$tera.project.TrialWizard.participantDropOuts"
			bookmark="drop-outs"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputSampleSize from "./OutputSampleSize.vue";

export default {
	data() {
		return {
			outputComponent: OutputSampleSize,
			trialTypeOptions: [
				"non-inferiority",
				"equivalence",
				"superiority",
				"other"
			],
			studyPowerOptions: ["80%", "90%", "other"],
			levelOfSignificanceOptions: ["5%", "1%", "other"],
			//new added
			trialDesignOptions: [
				{ label: "parallel group" },
				{ label: "crossover" },
				{ label: "factorial" },
				{ label: "single group" },
				{ label: "allocation ratio" },
				{ label: "framework" }
			]
		};
	}
};
</script>
